import { IconDefinition, IconName } from "@fortawesome/fontawesome-svg-core";

export const copyClipboardIcon: IconDefinition = {
    prefix: "fas",
    iconName: "copy-clipboard" as IconName,
    icon: [
        18,
        18,
        [],
        "",
        "M18.6484 2.74609L16.5039 0.601562C16.293 0.390625 16.0117 0.25 15.6953 0.25H9.96484C8.69922 0.25 7.71484 1.26953 7.71484 2.5V11.5C7.75 12.7656 8.73438 13.75 10 13.75H16.75C17.9805 13.75 19 12.7656 19 11.5V3.55469C19 3.23828 18.8594 2.95703 18.6484 2.74609ZM17.3125 11.5C17.3125 11.8164 17.0312 12.0625 16.75 12.0625H9.96484C9.64844 12.0625 9.40234 11.8164 9.40234 11.5V2.53516C9.40234 2.21875 9.64844 1.97266 9.96484 1.97266H14.4648L14.5 3.625C14.5 4.25781 14.9922 4.75 15.625 4.75H17.2773V11.5H17.3125ZM10.5625 16C10.5625 16.3164 10.2812 16.5625 10 16.5625H3.21484C2.89844 16.5625 2.65234 16.3164 2.65234 16V7.03516C2.65234 6.71875 2.93359 6.47266 3.21484 6.47266H6.625V4.75H3.21484C1.98438 4.75 0.964844 5.76953 0.964844 7L1 16C1 17.2656 1.98438 18.25 3.25 18.25H10C11.2305 18.25 12.25 17.2656 12.25 16V14.875H10.5625V16Z",
    ],
};
